var carouselEvent = require('src/interlock/ui/owl-carousel/carousel-events');
var eventToolbox = require('src/interlock/no-ui/utils/event-toolbox/event-toolbox');
var stringUtils =  require('src/interlock/no-ui/utils/string/string');
var prevSlideTo = -1;
//var vehicle = window.EDM.PageValues.vehicle;
//var BASE_LINKOUT = '/'+vehicle.make.niceName+'/'+
//    vehicle.model.niceName+'/'+vehicle.modelYear.year+
//    '/options/?legacy=true&sub='+vehicle.subModel.niceName+'&color=';

var any_color = 'any color';

var colorSlideMap = {};
colorSlideMap[any_color] = {val : -1};

var colorSwatchMap = {};

//function updateLinkout(colorText){
//    var color = '';
//    if(colorText !== '(any color)'){
//        color = trimSpaces(colorText);
//    }
//    $('.core-build-module .legacy-linkout')[0].href = BASE_LINKOUT + color;
//}

function changeColorTextByIndex(component, index, btnGroup){
    var colorText = component.find('.color-name-text')[0];
    colorText.textContent = btnGroup.eq(index)[0].dataset['colorName'];
//    updateLinkout(colorText.textContent);
}
function changeColorText(component, text){
    var colorText = component.find('.color-name-text')[0];
    colorText.textContent = text;
//    updateLinkout(text);
}

function totalIncrementer(slideObj, isClonedSlide){
    if(!slideObj.total){
        slideObj.total = 0;
    }
    if(!isClonedSlide){
        slideObj.total += 1;
    }
}

function mapColorSlides(slides){
    for (var i = 0, len = slides.length; i < len; i++){
        colorSlideMap[slides[i].dataset.color] = colorSlideMap[slides[i].dataset.color] ? colorSlideMap[slides[i].dataset.color] : {};
        if((colorSlideMap[slides[i].dataset.color].val !== 0 && !colorSlideMap[slides[i].dataset.color].val)
            || (colorSlideMap[slides[i].dataset.color].val > $(slides[i]).find('.item')[0].dataset.index)){
            colorSlideMap[slides[i].dataset.color] = {val : parseInt($(slides[i]).find('.item')[0].dataset.index)};
        }
        totalIncrementer(colorSlideMap[slides[i].dataset.color], $(slides[i]).closest('.owl-item').hasClass('cloned'));
    }
}

function getCenter(total){
    if(total === 3){
        return 1;
    }
    return 0;
}

function swatchClickHandler(e, carousel, btnGroup, component){
    e.preventDefault();

    if(Object.keys(colorSlideMap).length === 1){
        mapColorSlides($(carousel.find('.slide-container')));
    }
    var swatchOuter = $(e.target).closest('.swatch-outer')[0];
    var slideIndex = colorSlideMap[swatchOuter.dataset['colorName']].val;
    var speed = Math.floor(1500 / Math.abs(slideIndex - prevSlideTo));
    if(slideIndex > -1){
        var center = getCenter(colorSlideMap[swatchOuter.dataset['colorName']].total);
        carouselEvent.changeSlide(carousel, (slideIndex + center), speed);
        if(prevSlideTo === -1){
            changeColorText(component, swatchOuter.dataset['colorName']);
        }
    } else if(slideIndex === -1) {
        changeColorText(component, swatchOuter.dataset['colorName']);
    } else {
        slideIndex = prevSlideTo;
        changeColorText(component, swatchOuter.dataset['colorName']);
    }
    prevSlideTo = slideIndex;
    btnGroup.removeClass('selected');
    swatchOuter.classList.add('selected');
}

function mapSwatches(btnGroup){
    for(var i = 0, len = btnGroup.length;  i < len; i++){
        colorSwatchMap[btnGroup[i].dataset['colorName']] = i;
    }
}

function slideChangeHandler(e, btnGroup, component){
    if(Object.keys(colorSwatchMap ).length < 1){
        mapSwatches(btnGroup);
    }
    var currentColor = $($(e.target).find('.owl-item').not('.cloned')[e.page.index]).children('.slide-container')[0].dataset['color'];
    var pageIndex = colorSwatchMap[currentColor];
    changeColorTextByIndex(component, pageIndex, btnGroup);
    btnGroup.removeClass('selected');
    btnGroup.eq(pageIndex).addClass('selected');
}

function triggerSlide(target, carousel){
    var slideIndex = parseInt($(target).find('.item')[0].dataset.index);
    carouselEvent.changeSlide(carousel, slideIndex, 1000);
}

function fireLinkoutTracking(component){

    var selectedColor = component.find('.swatch-outer.selected')[0].dataset.colorName;
    if(selectedColor === any_color){
        selectedColor = '';
    }
    eventToolbox.fireAction({
        'event_type': 'action_start',
        'ads': {
            'disable_refresh': true
        },
        'event_data': {
            'action_name': 'configure_vehicle',
            'subaction_name': 'select_color',
            'action_cause': 'button_click',
            'value': stringUtils.urlFriendlySpaces(selectedColor)
        }
    });
}

module.exports = {
    swatchClickHandler: swatchClickHandler,
    slideChangeHandler: slideChangeHandler,
    fireLinkoutTracking: fireLinkoutTracking,
    triggerSlide: triggerSlide
};


//////////////////
// WEBPACK FOOTER
// ./src/interlock/core-page/build/controller.js
// module id = 174
// module chunks = 0 1 23